/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDtoSearchResponse } from '../../models/user-dto-search-response';

export interface SearchUsersAsync$Plain$Params {
  SearchText?: string;
  Top?: number;
  Skip?: number;
  SortBy?: string;
  SortDescending?: boolean;
  Roles?: Array<number>;
  ShowCustomers?: boolean;
  ShowInactives?: boolean;
}

export function searchUsersAsync$Plain(http: HttpClient, rootUrl: string, params?: SearchUsersAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDtoSearchResponse>> {
  const rb = new RequestBuilder(rootUrl, searchUsersAsync$Plain.PATH, 'get');
  if (params) {
    rb.query('SearchText', params.SearchText, {});
    rb.query('Top', params.Top, {});
    rb.query('Skip', params.Skip, {});
    rb.query('SortBy', params.SortBy, {});
    rb.query('SortDescending', params.SortDescending, {});
    rb.query('Roles', params.Roles, {});
    rb.query('ShowCustomers', params.ShowCustomers, {});
    rb.query('ShowInactives', params.ShowInactives, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDtoSearchResponse>;
    })
  );
}

searchUsersAsync$Plain.PATH = '/api/user';
